/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-unused-vars */


import {
  DataGridPro,
  GridValidRowModel,
  type GridRenderCellParams,
  GridRowParams,
  GridSortModel,
} from '@mui/x-data-grid-pro';
import React, {
  ReactNode,
  useState,
  type FC,
  useMemo,
  useCallback,
  useEffect,
} from 'react';


import { useNavigate } from 'react-router-dom';


import { LicenseInfo } from '@mui/x-license-pro';
import { useAppDispatch, useAppSelector } from '../../../rmsReduxStore/rmsReduxHooks';
import { getacalarmsReducer, getAcDashboardReducer, getAcReferenceDataReducer } from '../../rmsReduxStore/acReduxExports';
import { getAcFilterSelectedValue, getCurrentAcFiltersValues, setAcFilterData } from '../../rmsReduxStore/acFiltersRedux/acFiltersCreators';
import { alarmCardMapper, AlarmCards, CardPropTypes } from '../../../globalUtils/AlarmCards/AlarmCards';
import { Arrow, Icon } from '../../../globalUtils/globalIcons';
import { CustomTooltipWithLabel, formatRelativeTimeForTable, LoginLoader, NoDataComponentAlarms, SelectDropDown, SortedAscendingIcon, SortedDescendingIcon } from '../../../globalUtils/globalExports';
import { AlarmCardSkeleton, AlarmTableSkeleton } from '../../../globalUtils/SkeletonDesign/SkeletonDesign';
import {
  fetchAcAlarmCardCountData,
  fetchAcAlarmListData,
  setRedirectedStateForAcAlarmFilters
} from '../../rmsReduxStore/acAlarmsRedux/acAlarmCreators';
import { fetchNewAcDashboardAlarmSummaryList } from '../../rmsReduxStore/acDashboardRedux/acDashboardCreator';
import { fetchAcAlarmSeverityReferenceData } from '../../rmsReduxStore/acReferenceDataRedux/acReferenceDataCreator';

interface AlarmSummaryPropTypes {
  loader?: boolean,
  isNewDashBoard?:boolean,
  getFilterValue?: Function,
}

const AcAlarmSummary: FC<AlarmSummaryPropTypes> = (props) => {
  const { loader,isNewDashBoard, getFilterValue } = props;
  LicenseInfo.setLicenseKey('592863905b14abe78770cb5851e88222Tz04Nzg4MixFPTE3NDM5MjM4MzUwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=');
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const {alarmDashboardCount,alarms,alarmTableListLoader} = useAppSelector(getacalarmsReducer);
  const { alarmSeverityReferenceData } = useAppSelector(getAcReferenceDataReducer);


  const [value, setValue] = useState<IGeneralReferenceData>();
  const [selectedAlarmCard, setSelectedAlarmCard] = useState<string>('all')


    const handleAlarmFilter = useCallback(async (val): Promise<void> => {

      if (!alarmSeverityReferenceData) {
        await dispatch(fetchAcAlarmSeverityReferenceData())
      }
        const res = await setAcFilterData(val, 'severity', 'acalarms', 'SET', false)(dispatch)
        if (res?.message === 'Action dispatched successfully') {
             dispatch(fetchAcAlarmListData({ pageSize: 8, pageNumber: 1, filters: getCurrentAcFiltersValues('acalarms') }))
             dispatch(fetchAcAlarmCardCountData({filters: getCurrentAcFiltersValues('acalarms') }))

      }
    }, [alarmSeverityReferenceData])


    const handleCardChange = useCallback(async (val): Promise<void> => {

      if (!alarmSeverityReferenceData) {
        await dispatch(fetchAcAlarmSeverityReferenceData())
      }
        const res = await setAcFilterData(val, 'severity', 'acalarms', 'SET', false)(dispatch)
        if (res?.message === 'Action dispatched successfully') {
             dispatch(fetchAcAlarmListData({ pageSize: 8, pageNumber: 1, filters: getCurrentAcFiltersValues('acalarms') }))

      }
    }, [alarmSeverityReferenceData])
  

  const handleSelectChange = (val): void => {
    const cardValue = val?.label === 'All' ? 'TOTAL' : val?.value?.toString()?.toLocaleUpperCase()
    handleCardChange(val);
    setSelectedAlarmCard(cardValue);
  };

  const handleCardClick = useCallback((props: CardPropTypes): void => {
    // eslint-disable-next-line react/prop-types
    const { headerText } = props;
    // eslint-disable-next-line react/prop-types
    const value = headerText === 'TOTAL' ? 'all' : headerText[0] + headerText.slice(1).toLowerCase();
    setRedirectedStateForAcAlarmFilters(true, value)(dispatch)
        .then((res) => {
          if (res === 'Action dispatched successfully') {
            navigate('/ac/alarms', {
              state: { severityId: value }
            });
          }
        })
        .catch((error) => {
          console.error('Error dispatching action:', error); // Handle error
        });

  }, [alarmSeverityReferenceData])

  

  const handleSortModelChange = useCallback(
    (model: GridSortModel) => {
      if (model?.length > 0) {
        const sortOrder =
          model?.[0]?.sort === 'asc'
            ? 'ascending'
            : model?.[0]?.sort === 'desc'
              ? 'descending'
              : ''
        const dashboardCurrentFilters = getCurrentAcFiltersValues('acalarms');
        const sortField = (model?.[0]?.field?.length ?? 0) > 0 ? model?.[0]?.field : null;
        if(isNewDashBoard){
          dispatch(fetchNewAcDashboardAlarmSummaryList({ sortBy: sortField, order: sortOrder, pageSize: 8, pageNumber: 1, filters: dashboardCurrentFilters }))
        }
        else{
          dispatch(fetchAcAlarmListData({ sortBy: sortField, order: sortOrder, pageSize: 8, pageNumber: 1, filters: dashboardCurrentFilters }))
        }

      }
    }, [])

  const handleSelectedAlarm = useCallback((event, data) => {
    navigate('/ac/alarm?alarmId=' + data?.id, {
      state: {
        row: data,
        calledFrom: isNewDashBoard ? 'newDashboard' : 'dashboard'
      },
    });
  }, []);

  const columns = useMemo(() => {
    return [
      {
        field: 'severity',
        headerName: 'Alarm',
        minWidth: 50,
        maxWidth: 52,
        headerClassName: 'dashboard__alarm__header-severity',
        renderHeader: (): JSX.Element => {
          return (
            <div className='dashboard__alarm__header__alarm-icon'>
              <Icon iconClassName={'total__alarm__icon' + (isNewDashBoard ? ' iconScaleDown09' : '')} />
            </div>
          )
        },
        renderCell: (
          params: GridRenderCellParams<GridValidRowModel>
        ): ReactNode => {
          const rowData = params?.row;


          return (
            <div className="alarm__summary__name icon__severity">

              <Icon
                iconClassName={
                  alarmCardMapper[rowData?.severity]?.alarmSummaryIcon + (isNewDashBoard ? ' iconScaleDown09' : '')
                }
              />

            </div>
          );
        },
      },
      {
        field: 'alarmVisibleName',
        flex: 1.25,
        headerName: 'Alarm',
        minWidth: 100,
        renderCell: (
          params: GridRenderCellParams<GridValidRowModel>
        ): ReactNode => {
          const rowData = params?.row;
          return (
            <div className="alarm__summary__name">
              <div className="alarm__summary__name">
                { isNewDashBoard ? <CustomTooltipWithLabel label={rowData?.alarmVisibleName} labelId={rowData?.alarmVisibleName} /> : rowData?.alarmVisibleName }
              </div>
            </div>
          );
        },
      },
      {
        field: 'alarmSetTime',
        flex: 1,
        headerName: 'Time',
        minWidth: 90,
        renderCell: (
          params: GridRenderCellParams<GridValidRowModel>
        ): ReactNode => {
          const rowData = params?.row;
          const date = new Date(rowData?.alarmSetTime);
          if(isNewDashBoard) return <CustomTooltipWithLabel label={formatRelativeTimeForTable(date)} labelId={formatRelativeTimeForTable(date)} />
          return formatRelativeTimeForTable(date);
        },
      },
      {
        field: 'chargerVisibleId',
        headerName: 'Charger',
        minWidth: 100,
        editable: false,
        flex: 1,
        renderCell: (
          params: GridRenderCellParams<GridValidRowModel>
        ): ReactNode => {
          const rowData = params?.row;
          return (
            <div className="alarm__summary__charger__id">
              { isNewDashBoard ? <CustomTooltipWithLabel label={rowData?.chargerVisibleId} labelId={rowData?.chargerVisibleId} /> : rowData?.chargerVisibleId }
              <Arrow color="black" direction="right" />
            </div>
          );
        },
      },
    ];
  }, [alarmCardMapper]);

  const alarmsList = useMemo(() => {
    return alarms;
  }, [alarms])

  const getRows = useCallback(() => {
    const updatedAlarmsData =
      alarmsList !== null && alarmsList?.length > 0
        ? alarmsList?.map((alarm) => {
          const { alarmId, ...rest } = alarm;
          return { id: alarmId, ...rest };
        })
        : [];

    return updatedAlarmsData ?? [];
  }, [alarmsList]);

  // useEffect(() => {
  //   const severityFilterSelectedValues = getAcFilterSelectedValue('severity', isNewDashBoard ? 'dashboardV2' : 'dashboard', false)
  //   if (severityFilterSelectedValues && severityFilterSelectedValues?.length > 0) {
  //     const value = severityFilterSelectedValues?.[0].id;
  //     if (alarmSeverityReferenceData) {
  //       const filterValue = alarmSeverityReferenceData?.length > 0 && alarmSeverityReferenceData?.find(item => item?.id?.toLocaleLowerCase() === value?.toLocaleLowerCase());
  //       if (filterValue) {
  //         setValue(filterValue)
  //       }
  //     }
  //     setSelectedAlarmCard(value == 'all' ? 'TOTAL' : value.toUpperCase());
  //   } else {
  //     setSelectedAlarmCard('TOTAL');
  //   }
  // }, [])

  useEffect(() => {
  if (!alarmSeverityReferenceData) return;

  const severityFilterSelectedValues =
    getAcFilterSelectedValue(
      'severity',
     'acalarms',
      false
    );

  if (severityFilterSelectedValues?.length > 0) {
    const selectedId = severityFilterSelectedValues[0].id;

    const filterValue = alarmSeverityReferenceData.find(
      item => item.id.toLowerCase() === selectedId.toLowerCase()
    );

    if (filterValue) {
      setValue(filterValue); // exact option object
      setSelectedAlarmCard(
        selectedId === 'all' ? 'TOTAL' : selectedId.toUpperCase()
      );
    }
  } else {
    setValue(undefined);
    setSelectedAlarmCard('TOTAL');
  }
}, [alarmSeverityReferenceData, isNewDashBoard]);

  useEffect(()=>{
 dispatch(fetchAcAlarmListData({ pageSize: 8, pageNumber: 1, filters:getCurrentAcFiltersValues('acalarms') }))
dispatch(fetchAcAlarmSeverityReferenceData())
  },[])



  return (
    <div className="alarm__summary__container">
      <div className="alarm__summary-header-wrap">
        <div className="widget-heading  alarm__summary-header">Active Alarms
        </div>
        {/* <IconWithTooltip iconClassName='info-icon' toolTipText={''} /> */}
        <div className="alarm__summary-dropdown">
          <SelectDropDown
            selectValue={value}
            selectOptions={alarmSeverityReferenceData?.filter((item) => item.id !== 'No Alarm') ?? []}
            handleSelectOptionChange={handleSelectChange}
            selectDropDownId="alarm-summary-dropdown"
            isMultiSelect={false}
          />
        </div>
      </div>

      {!alarmDashboardCount ? (
        <AlarmCardSkeleton />
      ) : (
        <div className="alarm__summary-cards-wrap">
          {alarmDashboardCount &&
            alarmDashboardCount !== null &&
            alarmDashboardCount?.length > 0 &&
            alarmDashboardCount?.map((alarmType, index) => (
              <AlarmCards
                key={alarmType?.severity + index}
                alarmContainerClassName="alarms__dashboard__container-alarm-cards"
                cardId={`alarm-summary-${alarmType?.severity}`}
                alarmCount={alarmType?.alarmCount}
                headerText={alarmType?.severity}
                onCardClick={handleCardClick}
                selectedCard={selectedAlarmCard}
                loader={loader}
              />
            ))}
        </div>
      )}

      <div className="alarm__summary-table">
        {!alarmsList ? (
          <AlarmTableSkeleton />
        ) : (
          <DataGridPro
            rows={getRows() ?? []}
            columns={columns}
            disableColumnMenu
            disableColumnReorder
            key={'alarm-summary-table'}
            className={'alarm__summary-table'}
            rowHeight={36}
            loading={alarmTableListLoader || false}
            slots={{
              footer: () => null,
              noRowsOverlay: NoDataComponentAlarms,
              columnSortedAscendingIcon: SortedAscendingIcon,
              columnSortedDescendingIcon: SortedDescendingIcon,
              loadingOverlay: LoginLoader
            }}
            getRowClassName={(): string => {
              return 'alarm__summary__table-dashboard-row';
            }}
            sortingMode="server"
            onSortModelChange={handleSortModelChange}

            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            onRowClick={(rowData: GridRowParams<GridValidRowModel>, e) => {
              //navigate('/alarms?alarmId=' +rowData.row );
              (handleSelectedAlarm(e, rowData.row))
            }
            }
          />
        )}
      </div>

    </div>
  );
};

export default AcAlarmSummary;